import React from "react";
/**
 * BreadCatalogCard — Table row component for product listing.
 * Renders as a <tr> inside the category table.
 */

function getStatusInfo(bread) {
  if (!bread.enabled) return { label: 'AGOTADO', type: 'inactive' };
  if (bread.disabled_store_ids && bread.disabled_store_ids.length > 0) {
    return { label: 'PARCIAL', type: 'partial' };
  }
  return { label: 'DISPONIBLE', type: 'active' };
}

/**
 * Generate a product PLU from category + name.
 */
function generateProductPlu(bread, index) {
  const catPrefix = (bread.category || 'XX').substring(0, 1).toUpperCase();
  const namePrefix = (bread.name_es || 'X').substring(0, 1).toUpperCase();
  const num = String((index || 0) + 1).padStart(3, '0');
  return `${catPrefix}${namePrefix}-${num}`;
}

export default function BreadCatalogCard({ bread, categoryMeta, onClick, index, onToggleEnabled, onDelete, groupIdx }) {
  const status = getStatusInfo(bread);
  const plu = generateProductPlu(bread, index);

  const handleToggle = (e) => {
    e.stopPropagation();
    if (onToggleEnabled) {
      onToggleEnabled(bread);
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onClick) onClick();
  };

  // Determine icon box style — alternate based on group
  const iconBoxClass = (groupIdx || 0) % 2 !== 0 ? 'orange' : 'slate';

  return (
    <tr onClick={onClick} style={{ cursor: 'pointer' }}>
      {/* Producto */}
      <td>
        <div className="bc-product-cell">
          <div className={`bc-product-icon-box ${iconBoxClass}`}>
            {bread.image_url ? (
              <img
                src={bread.image_url}
                alt={bread.name_es}
                loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '0.5rem' }}
              />
            ) : (
              <span className="material-symbols-outlined">bakery_dining</span>
            )}
          </div>
          <div className="bc-product-info">
            <div className="bc-product-name-row">
              <span className="bc-product-name">{bread.name_es}</span>
            </div>
            <span className="bc-product-plu">PLU: {plu}</span>
          </div>
        </div>
      </td>

      {/* Estado */}
      <td>
        {status.type === 'active' ? (
          <div className="bc-status-disponible">
            <span className={`bc-status-dot ${index === 0 ? 'animate' : ''}`} />
            <span className="bc-status-label">{status.label}</span>
          </div>
        ) : status.type === 'inactive' ? (
          <div className="bc-status-agotado">
            <span className="bc-status-label">{status.label}</span>
          </div>
        ) : (
          <div className="bc-toggle-wrapper" onClick={(e) => e.stopPropagation()}>
            <label className="bc-toggle">
              <input
                type="checkbox"
                checked={bread.enabled}
                onChange={handleToggle}
              />
              <span className="bc-toggle-track" />
            </label>
            <span className="bc-toggle-label">
              {bread.enabled ? 'Activo' : 'Inactivo'}
            </span>
          </div>
        )}
      </td>

      {/* Detalles Técnicos */}
      <td>
        <span className="bc-details-text">
          {bread.description_es || bread.notes || '—'}
        </span>
      </td>

      {/* Acciones */}
      <td>
        <div className="bc-actions">
          <button
            className="bc-action-btn edit"
            onClick={handleEdit}
            type="button"
            title="Editar"
          >
            <span className="material-symbols-outlined">edit</span>
          </button>
          <button
            className={`bc-action-btn toggle-power ${bread.enabled ? 'on' : 'off'}`}
            onClick={(e) => { e.stopPropagation(); onToggleEnabled && onToggleEnabled(bread); }}
            type="button"
            title={bread.enabled ? 'Desactivar' : 'Activar'}
          >
            <span className="material-symbols-outlined">
              {bread.enabled ? 'toggle_on' : 'toggle_off'}
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
}
